/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import "./Space.scss";
import { ReactComponent as Plus } from "../../assets/icon/plus.svg";
import { ReactComponent as Replace } from "../../assets/icon/exchange.svg";
import { ReactComponent as Map } from "../../assets/icon/map.svg";
import { ReactComponent as Floor } from "../../assets/icon/floor.svg";
import {
  getImageForMinimap,
  getMiniMap,
  getPoi,
} from "../../crud/showcase/showcase";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Arrow } from "../../assets/icon/direction.svg";
import { ReactComponent as ZoomIn } from "../../assets/icon/zoom_in.svg";
import { ReactComponent as ZoomOut } from "../../assets/icon/zoom_out.svg";
import { ReactComponent as Reset } from "../../assets/icon/reset.svg";
import {
  hideLoaderAction,
  showLoaderAction,
  showSimpleModalAction,
} from "../../redux/actions";
import { removeAll } from "../../helpers/poiFunction";
import ModalPoint from "../ModalPoint/ModalPoint";
import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import classNames from "classnames";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { setShareParams, setSweepId, setSweepNumber } from '../../helpers/rotationStore';

const MinimapSpaceBtn = styled("button", {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color }) => ({
  "&:hover": {
    background: "rgba(0, 0, 0, 0.8)",
    color,
    fill: color,
  },
  "&:active": {
    background: "rgba(0, 0, 0, 1)",
    color,
    fill: color,
  },
}));

const SpaceFloor = styled("span", {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color }) => ({
  "&:hover": {
    color,
  },
  "&.space_floor--active": {
    color,
  },
}));

const sdkVersion = "3.5";

const Space = ({
  content,
  space,
  point,
  setMatterport,
  menu,
  changeContent,
  setRemoveActiveLink,
}) => {
  const isFirstTimeOpenMinimap = useRef(true);
  const [isMainFrame, setIsMainFrame] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [floorShow, setFloorShow] = useState(true);
  const [showCase, setShowCase] = useState(null);
  const [isDisabledMinimap, setIsDisabledMinimap] = useState(false);
  const [floor, setFloor] = useState([]);
  const [currFloor, setCurrFloor] = useState(null);
  const [findFloor, setFindFloor] = useState(null);
  const [minimapImg, setMinimapImg] = useState(null);
  const [listPoi, setListPoi] = useState([]);
  const [currentPoi, setCurrentPoi] = useState(null);
  const [mapImg, setMapImg] = useState(null);
  const [pose, setPose] = useState(null);
  const sweeps = useRef(null);
  const [floorSweeps, setFloorSweeps] = useState(null);
  const [floorPoi, setFloorPoi] = useState(null);
  const [isSpaceLoad, setIsSpaceLoad] = useState(false);
  const dispatch = useDispatch();
  const resetZoom = useRef();
  const zoomRef = useRef();
  const ref = useRef();
  const { t } = useTranslation();
  const color = useSelector((state) => state.profile.color);
  const matterportSdkKey = useSelector(
    (state) => state.profile.matterportSdkKey
  );
  const showMinimapClassnames = classNames({
    "space-show-minimap space-show-minimap--floor": true,
    "space-show-minimap--active": floorShow,
  });
  const poseSubscription = useRef(null); // Para rastrear la suscripción a Camera.pose

  const removeActive = () => {
    changeContent(false);
    setRemoveActiveLink(true);
  };

  const handleOpenMinimap = () => {
    setIsOpen((prev) => !prev);
    const bodyWidth = document.body.clientWidth <= 576;
    if (bodyWidth) {
      resetZoom.current.click();
      setIsMainFrame(true);
    }
  };

  const handleMain = (e) => {
    resetZoom.current.click();
    setIsMainFrame((prev) => !prev);
  };

  useEffect(() => {
    if (showCase) {
      showCase?.App?.state?.subscribe(function (appState) {
        if (appState.phase === showCase.App.Phase.PLAYING) {
          setIsSpaceLoad(true);
        }
      });
    }
  }, [showCase]);
  useEffect(() => {
    if (
      space?.showMinimap &&
      isFirstTimeOpenMinimap &&
      (minimapImg?.preview || mapImg)
    ) {
      setTimeout(() => {
        setIsOpen(false);
      }, 500);
      isFirstTimeOpenMinimap.current = false;
    }
  }, [space, mapImg, minimapImg?.preview]);
  const getPoint = (mpSdk) => {
    let idSpace = space?.id;
    if (!Number.isInteger(idSpace) || !space?.visibility?.poisVisibility)
      return;
    dispatch(showLoaderAction());
    getPoi(idSpace)
      .then((res) => {
        // filter - remove all enable poi
        function filterPoi(poi) {
          //Always null i remove when add space all poi
          poi.matterPortId = null;
          poi.checked = true;
          return poi.enabled === true;
        }

        let data = res.data.list.filter(filterPoi);

        // Format icon URLs before passing to removeAll (Matterport SDK)
        // Normalize URLs to the correct bucket based on environment
        data = data.map(item => {
          if (item.icon) {
            // Determine the correct bucket based on environment            
            const targetBucket = process.env.REACT_APP_DO_ENDPOINT

            console.log('[POI Icons - Showcase] Processing icon URL for', item.name);
            console.log('[POI Icons - Showcase] Original URL:', item.icon);
            console.log('[POI Icons - Showcase] Target bucket:', targetBucket);

            // Normalize the URL by replacing various old endpoints with the target bucket
            let iconUrl = item.icon
              .replace('https://dev.api.akrotonx.com', targetBucket)
              .replace('https://development.api.akrotonx.com', targetBucket)
              .replace('https://akrotonx-develop.fra1.digitaloceanspaces.com', targetBucket)
              .replace('https://akrotonx-prod.fra1.digitaloceanspaces.com', targetBucket)
              .replace(/^undefined\//, ''); // Remove 'undefined/' prefix if present

            // If the URL doesn't start with http, prepend the target bucket
            if (!iconUrl.startsWith('http')) {
              iconUrl = `${targetBucket}/${iconUrl}`;
            }

            item.icon = iconUrl;
            console.log('[POI Icons - Showcase] Normalized URL:', item.icon);
          }
          return item;
        });

        return removeAll(mpSdk, data);
      })
      .then((arr) => {
        const setPoi = arr.map((item) => {
          item.isShowOnMinimap = true;
          return item;
        });
        setListPoi(arr);
        point(setPoi);
      })
      .catch((err) => {
        console.error('[POI Icons - Showcase] Error loading POIs:', err);
        const errors = err?.response?.data;
        if (errors) {
          const { error, message, statusCode } = errors;
          if (statusCode !== 401) {
            dispatch(showSimpleModalAction({ title: "Error", text: message }));
          }
        } else {
          // Handle non-HTTP errors (like SDK errors)
          dispatch(showSimpleModalAction({
            title: "Error",
            text: err?.message || "Failed to load POIs"
          }));
        }
      })
      .finally(() => {
        dispatch(hideLoaderAction());
      });
  };
  const getFloorSpace = () => {
    let idSpace = space?.id;
    if (!Number.isInteger(idSpace) || !space?.userInterface?.floorsEnabled)
      return;
    dispatch(showLoaderAction());
    getMiniMap(idSpace)
      .then((res) => {
        let miniMap = res.data?.map((floor) => {
          floor.active = false;
          return floor;
        });
        setFloor(miniMap);
      })
      .catch((err) => {
        const errors = err?.response?.data;
        const { error, message, statusCode } = errors;
        dispatch(showSimpleModalAction({ title: "Error", text: message }));
      })
      .finally(() => {
        dispatch(hideLoaderAction());
      });
  };

  const getImgForMinimap = (id) => {
    if (!id) {
      setMinimapImg(null);
      setIsMainFrame(true);
      //setIsOpen(true)
      setIsDisabledMinimap(true);
      return;
    }
    dispatch(showLoaderAction());
    getImageForMinimap(id)
      .then((res) => {
        if (res?.data?.size === 0) {
          setMinimapImg(null);
          return;
        }
        // if (res?.data) {
        //   setMinimapImg(res.data);
        // }
        // const reader = new window.FileReader();
        // reader.readAsDataURL(res.data);
        let result = { preview: res.data }; //reader.result };
        setMinimapImg(result);
        // reader.onload = function () {
        //   let result = { preview: res.data }; //reader.result };
        //   console.log("result", result);
        //   setMinimapImg(result);
        // };
      })
      .catch((err) => {
        console.error(err);
        const errors = err?.response?.data;
        // if (!errors) return;
        const message = errors?.message || "Error";
        dispatch(showSimpleModalAction({ title: "Error", text: message }));
        setMinimapImg(null);
        setIsMainFrame(true);
        //setIsOpen(true)
        setIsDisabledMinimap(true);
      })
      .finally(() => {
        dispatch(hideLoaderAction());
      });
  };
  // get all sweeps
  useEffect(() => {
    if (showCase !== null) {
      showCase.Model.getData()
        .then(function (model) {
          sweeps.current = model.sweeps;
        })
        .catch(function (error) {
          // Model data retrieval error.
        });
    }
  }, [showCase]);
  const mobileChangeViewWhenSweep = () => {
    const bodyWidth = document.body.clientWidth <= 576;
    const isNotMainFram = !isMainFrame;
    if (isNotMainFram && bodyWidth) {
      handleMain();
    }
  };

  const goToSweep = async (sweep, rotationOverride = null) => {
    if (!showCase) {
      console.error('showCase is not defined');
      return;
    }

    // Convertir radianes a grados
    const radiansToDegrees = (radians) => radians * (180 / Math.PI);

    // Convertir la rotación al rango esperado
    const convertRotation = (rotation, sweepRotation) => {
      let { x, y } = rotation;
      let substract = true;

      // console.log('debug pitch:', x); // Depuración
      // if x is negative, then substract is true
      if (x < 0)
        substract = false;

      // Convertir de radianes a grados solo para 'y'
      y = radiansToDegrees(y);
      x = radiansToDegrees(x);

      // console.log('debug rad2deg x:', x); // Depuración

      // console.log('debug sweepRotation.x: ', sweepRotation.x);
      // console.log('debug sweepRotation.y: ', sweepRotation.y);

      // Compensar con la rotación del sweep solo para 'y'
      // if(substract)
      //   x = x+90;
      // else{
      //   x = x-180;
      //   x = -x;
      // }

      y += sweepRotation.x; // Sumar la rotación en 'x' del sweep al 'y' actual

      // console.log('debug compensated x:', x); // Depuración

      // Normalizar x (pitch) al rango [-90, 90]
      // x = Math.max(-90, Math.min(90, x));
      // console.log('debug normalized x:', x); // Depuración

      // Normalizar y (yaw) al rango [-360, 360]
      y = ((y % 360) + 360) % 360; // Asegura que esté positivo
      if (y > 180) y -= 360; // Ajusta al rango [-180, 180]

      // Devolver 'x' sin cambios y el nuevo valor de 'y'
      return { x, y };
    };

    // Obtener la rotación del sweep
    const sweepRotation = sweep.rotation || { x: 0, y: 0 };

    // Verificar si se proporciona una rotación personalizada
    const rotation = rotationOverride;
    // const rotation = rotationOverride
    //   ? convertRotation(rotationOverride, sweepRotation) // Aplicar la conversión y compensar con el sweep
    //   : convertRotation({ x: 0, y: 0 }, sweepRotation); // Rotación por defecto si no se proporciona

    // console.log('Moving to sweep:', sweep.sid, 'with rotation:', rotation); // Depuración

    const transition = showCase.Sweep.Transition.FLY;
    const transitionTime = 2000; // en milisegundos
    mobileChangeViewWhenSweep();

    try {
      // Mover al sweep con la rotación especificada
      await showCase.Sweep.moveTo(sweep.sid, {
        rotation: rotation, // Aplicar la rotación convertida
        transition: transition,
        transitionTime: transitionTime,
      });
      // console.log('Moved to sweep successfully with rotation:', rotation);
    } catch (e) {
      console.error('Error in goToSweep:', e);
    }
  };

  const goToPoi = async (poi) => {
    let sidPoi = poi.matterPortId;
    let find = listPoi.find((point) => point.id === poi.id);
    setCurrentPoi(find);
    try {
      await showCase.Mattertag.navigateToTag(
        sidPoi,
        showCase.Mattertag.Transition.FLY
      );
    } catch (e) {
      debugger;
    }
  };

  const percentage = (value, totalValue) => {
    return (100 * value) / totalValue;
  };

  const parseToProcent = (minimapData, floors) => {
    const currentFloor = floors | currFloor;
    if (minimapData === null || minimapData === undefined) return;
    const currSettingMinimap = minimapData[0];
    if (!currSettingMinimap) return;
    let findItem = floor.find((item) => item.floor === currentFloor);
    setFindFloor(findItem);
    let sortSweeps = sweeps?.current
      ?.filter((sweep) => sweep.floor + 1 === currentFloor)
      .map((sweep) => {
        let px =
          ((sweep.position.x - currSettingMinimap.image_origin_x) *
            currSettingMinimap.resolution_ppm) /
          currSettingMinimap.width;
        px = px * 100 * (findItem?.setting?.width || 1) + "%";
        let py =
          ((sweep.position.z * -1 - currSettingMinimap.image_origin_y) *
            currSettingMinimap.resolution_ppm) /
          currSettingMinimap.height;
        py = py * 100 * (findItem?.setting?.height || 1) + "%";
        sweep.px = {
          right: px,
          bottom: py,
        };
        return sweep;
      });
    setFloorSweeps(sortSweeps);
    let sortPoi = listPoi
      ?.filter((poi) => poi.floor === currentFloor)
      .map((poi) => {
        let px =
          ((poi.x - currSettingMinimap.image_origin_x) *
            currSettingMinimap.resolution_ppm) /
          currSettingMinimap.width;
        px = px * 100 * (findItem?.setting?.width || 1) + "%";
        let py =
          ((poi.z * -1 - currSettingMinimap.image_origin_y) *
            currSettingMinimap.resolution_ppm) /
          currSettingMinimap.height;
        py = py * 100 * (findItem?.setting?.height || 1) + "%";
        poi.px = {
          right: px,
          bottom: py,
        };
        return poi;
      });
    setFloorPoi(sortPoi);
  };

  function formatImageUrl(image) {
    if (!image.startsWith("http://") && !image.startsWith("https://")) {
      return `https://${image}`;
    }
    if (image.startsWith("http://")) {
      return image.replace("http://", "https://");
    }
    return image;
  }

  const getImgFloor = (floors) => {
    const currentFloor = floors | currFloor;
    const findFloor = floor?.find((item) => item.floor === currentFloor);
    if (!findFloor) return;
    const image = findFloor.image;
    setMapImg(formatImageUrl(image));
  };
  //Every time when is true we dont have a img floor plan and need render minimap
  useEffect(() => {
    if (currFloor && typeof currFloor == "number") {
      parseToProcent(space?.minimapSettings);
      getImgFloor(undefined);
    }
    if (
      (currFloor === "reset" || currFloor === null) &&
      !mapImg &&
      !mapImg?.preview
    ) {
      parseToProcent(space?.minimapSettings, 1);
      getImgFloor(1);
    }
  }, [currFloor, space, listPoi, floor]);

  useEffect(() => {
    if (ref && space !== null) {
      async function onshowcaseConnect(mpSdk) {
        setShowCase(mpSdk);
        setMatterport(mpSdk);
        try {
          const modelData = await mpSdk.Model.getData();
          getPoint(mpSdk);

          // const initialSweep = modelData.sweeps[0];
          // if (initialSweep) {
          //   setTimeout(() => gotToSweep(initialSweep), 2000);
          // }
        } catch (e) { }
      }

      const handlePlaySpace = async () => {
        const iframe = document.getElementById("showcase-iframe");
        try {
          const mpSdk = await window.MP_SDK.connect(
            iframe,
            matterportSdkKey, // key
            sdkVersion // Unused but needs to be a valid string
          );
          onshowcaseConnect(mpSdk);
        } catch (e) {
          console.error("handlePlaySpace", e);
        }
      };

      handlePlaySpace();
    }
  }, [ref, space, matterportSdkKey]);
  useEffect(() => {
    getFloorSpace();
  }, [space?.id]);
  //Change mode for Meas
  useEffect(() => {
    if (!showCase) return;
    else if (showCase && content?.text === "Measurements") {
      showCase?.Measurements.toggleMode(true).then(() => {
        console.log("measurement mode is now active").catch((e) => {
          console.error("handlePlaySpace", e);
        });
      });
    } else {
      showCase?.Measurements.toggleMode(false)
        .then(() => {
          console.log("measurement mode is now active");
        })
        .catch((e) => {
          console.error("handlePlaySpace", e);
        });
    }
  }, [showCase, content]);
  //Change mode for 3d
  useEffect(() => {
    if (!showCase) return;
    else if (showCase && content?.text === "3D") {
      const mode = showCase?.Mode?.Mode?.DOLLHOUSE;
      const transition = showCase?.Mode?.TransitionType?.FLY;
      showCase?.Mode?.moveTo(mode, {
        transition: transition,
      }).then(function (nextMode) { });
    } else {
    }
  }, [showCase, content]);
  //if active Content hide curr poi
  useEffect(() => {
    if (content) {
      setCurrentPoi(null);
    }
  }, [content]);

  // Asegurar que también la limpieza sea correcta en el useEffect
  useEffect(() => {
    if (showCase?.Floor) {
      observableFloor();
      startListenPose();
    }

    return () => {
      // Limpiar la suscripción cuando el componente se desmonte
      if (poseSubscription.current) {
        try {
          poseSubscription.current();
        } catch (error) {
          console.warn("Error cleaning up pose subscription:", error);
        }
        poseSubscription.current = null;
      }
    };
  }, [showCase?.Floor, floorSweeps]);

  const observableFloor = () => {
    showCase?.Floor.current.subscribe(function (currentFloor) {
      if (currentFloor.sequence === -1) {
        setCurrFloor("reset");
      } else if (currentFloor.sequence === undefined) {
        if (currentFloor.id === undefined) {
        } else {
        }
      } else {
        let currFloor = currentFloor.sequence + 1;
        setCurrFloor(currFloor);
      }
    });
  };

  // backup code
  // this code was comented inside startListenPose function
  // console.log(findSweep)
  // const getResourse = space?.minimapSettings[0]
  // let px =
  //   ((pose.position.x - getResourse.image_origin_x) *
  //     getResourse.resolution_ppm) /
  //   getResourse.width
  // px = px * 100 + '%'
  // let py =
  //   ((pose.position.z * -1 - getResourse.image_origin_y) *
  //     getResourse.resolution_ppm) /
  //   getResourse.height
  // py = py * 100 + '%'

  const startListenPose = () => {
    // Desuscribir anteriores suscripciones si existen
    if (poseSubscription.current) {
      try {
        // La función de desuscripción está almacenada en poseSubscription.current
        poseSubscription.current();
      } catch (err) {
        console.warn("Error unsubscribing from pose:", err);
      }
      poseSubscription.current = null;
    }

    if (!showCase?.Camera?.pose) {
      console.warn("Camera pose API not available");
      return;
    }

    // Guardar la referencia de la FUNCIÓN de desuscripción que devuelve subscribe
    const unsubscribeFn = showCase.Camera.pose.subscribe(function (pose) {
      if (!pose || space === null) return;

      // console.log("Pose:", pose); // Confirmar que recibimos actualizaciones de pose

      // Establecer las coordenadas inmediatamente, incluso sin sweep
      let yRotationForURL = pose.rotation.y.toFixed(2);
      let xRotationForURL = pose.rotation.x.toFixed(2);
      const sr = `${yRotationForURL},${xRotationForURL}`;
      setShareParams(sr);

      // Identificar el sweep actual
      const findSweep = floorSweeps?.find((sweep) => sweep.uuid === pose.sweep);

      if (findSweep) {
        const sweepNumber = floorSweeps.findIndex((s) => s.uuid === findSweep.uuid) + 1;
        if (sweepNumber) {
          setSweepNumber(sweepNumber);
          setSweepId(findSweep.sid);
          // console.log(`Position updated - Sweep #${sweepNumber}, SID: ${findSweep.sid}, Rotation: ${sr}`);
        }

        // Minimap navigation arrow update section
        let initial = pose.rotation.y;
        if (Math.sign(pose.rotation.y) === -1) {
          //initial += 180
          if (Math.abs(initial) >= 90) {
            initial = Math.abs(initial) - 90;
          } else {
            initial = 270 + Math.abs(initial);
          }
        } else {
          if (Math.abs(initial) >= 90) {
            initial = 180 - Math.abs(initial) + 90;
          } else {
            initial = 270 - Math.abs(initial);
          }
        }
        setPose({
          left: findSweep?.px?.right,
          bottom: findSweep?.px?.bottom,
          rotation: initial,
          rotationOriginal: pose.rotation,
        });
        // Minimap navigation arrow update section end
      } else if (pose.sweep) {
        updateSweepFromSDK(pose.sweep);
      }
    });

    // Almacenar la función de desuscripción
    poseSubscription.current = unsubscribeFn;

    // Forzar una actualización inicial de la posición
    requestAnimationFrame(async () => {
      try {
        const initialPose = await showCase.Camera.getPose();
        updatePositionFromPose(initialPose);
      } catch (err) {
        console.warn("Could not get initial pose:", err);
      }
    });
  };

  // Función para actualizar la posición basada en un pose
  const updatePositionFromPose = (pose) => {
    if (!pose) return;

    let yRotationForURL = pose.rotation.y.toFixed(2);
    let xRotationForURL = pose.rotation.x.toFixed(2);
    const sr = `${yRotationForURL},${xRotationForURL}`;
    setShareParams(sr);

    if (pose.sweep) {
      updateSweepFromSDK(pose.sweep);
    }
  };

  // Función para obtener información del sweep directamente desde el SDK
  const updateSweepFromSDK = async (sweepId) => {
    if (!showCase) return;

    try {
      const modelData = await showCase.Model.getData();
      if (!modelData || !modelData.sweeps) return;

      const sweepIndex = modelData.sweeps.findIndex(s => s.sid === sweepId);
      if (sweepIndex >= 0) {
        const sweepNumber = sweepIndex + 1;
        setSweepNumber(sweepNumber);
        setSweepId(sweepId);
        // console.log(`Sweep updated via SDK - Sweep #${sweepNumber}, SID: ${sweepId}`);
      }
    } catch (err) {
      console.warn("Error updating sweep from SDK:", err);
    }
  };

  // change state for active floor tabs
  useEffect(() => {
    if (floor?.length > 0 && currFloor) {
      if (currFloor === "reset") {
        let update = floor
          .map((item) => {
            item.active = false;
            return item;
          })
          .reverse();
        setFloor(update);
      } else {
        let update = floor.map((item) => {
          if (item.floor === currFloor) {
            item.active = true;
            return item;
          } else {
            item.active = false;
            return item;
          }
        });
        let findItem = floor.find((item) => item.floor === currFloor);
        //checkIsActiveMinimap(findItem)
        getImgForMinimap(findItem?.minimapId);
        setFloor(update);
      }
    }
  }, [currFloor]);

  const handleChangeFloor = (e, item) => {
    dispatch(showLoaderAction());
    let moveToFloor = item.floor - 1;
    showCase.Floor.moveTo(moveToFloor)
      .then((res) => { })
      .finally(() => {
        dispatch(hideLoaderAction());
      });
  };
  const spaceUrlCreator = () => {
    if (space !== null) {
      const {
        autoplay,
        guidedTourDelay,
        help,
        highlightReelLaunching,
        newTab,
        quickstart,
      } = space.launching;
      const { callToAction, loop, pan, title } = space.guidedTours;
      const { floorsEnabled, scrollWheel, zoomDisabled } = space.userInterface;
      const {
        brandVisibility,
        conferenceCallVisibility,
        dollhouseViewVisibility,
        floorplanVisibility,
        guidedTourButtonsVisibility,
        highlightReelVisibility,
        pinsVisibility,
        poisVisibility,
        portalVisibility,
        removeInfoPanelVisibility,
        shareButtonVisibility,
        vrButtonVisibility,
      } = space.visibility;
      const launchingSettingString = `&play=${autoplay ? 1 : 0}&help=${help ? 1 : 0
        }&nt=${newTab ? 1 : 0}&qs=${quickstart ? 1 : 0}&hl=${highlightReelLaunching ? 1 : 0
        }&ts=${guidedTourDelay}`;
      const guidedToursSettingStrind = `&kb=${pan ? 1 : 0}&lp=${loop ? 1 : 0
        }&title=0&tourcta=${callToAction ? 1 : 0}`;
      const userInterfaceSettingString = `&f=${floorsEnabled ? 1 : 0}&nozoom=${zoomDisabled ? 1 : 0
        }&wh=${scrollWheel ? 1 : 0}`;
      const visibilitySettingString1 = `&brand=0&dh=${dollhouseViewVisibility ? 1 : 0
        }&fp=${floorplanVisibility ? 1 : 0}&gt=${guidedTourButtonsVisibility ? 1 : 0
        }&hr=${highlightReelVisibility ? 1 : 0}`;
      const visibilitySettingString2 = `&mls=${removeInfoPanelVisibility ? 2 : 1
        }&mt=${poisVisibility ? 1 : 0}&pin=${pinsVisibility ? 1 : 0}&portal=${portalVisibility ? 1 : 0
        }&vr=${vrButtonVisibility ? 1 : 0}`;
      const startLocation = `${space?.additionalposition !== null ? space?.additionalposition : ""
        }`;
      return (
        launchingSettingString +
        guidedToursSettingStrind +
        userInterfaceSettingString +
        visibilitySettingString1 +
        visibilitySettingString2
      );
    }
  };

  // for renderPoi
  useEffect(() => {
    if (space !== null && showCase !== null && listPoi?.length > 0) {
      showCase.Tag.openTags.subscribe({
        prevState: {
          hovered: null,
          docked: null,
          selected: null,
        },
        onChanged(newState) {
          if (newState.hovered !== this.prevState.hovered) {
            if (newState.hovered) {
              //was hovered
              let find = listPoi.find(
                (poi) => poi.matterPortId === newState?.hovered
              );
              if (find?.mouseAction) {
                removeActive();
                setCurrentPoi(find);
              }
            } else {
              // is no longer hovered
            }
          }
          /*if (newState.docked !== this.prevState.docked) {
            if (newState.docked) {
              console.log(newState.docked, 'was docked');
            } else {
              console.log(this.prevState.docked, 'was undocked');
            }
          }*/

          // only compare the first 'selected' since only one tag is currently supported
          const [selected = null] = newState.selected; // destructure and coerce the first Set element to null
          if (selected !== this.prevState.selected) {
            if (selected) {
              let find = listPoi.find((poi) => poi.matterPortId === selected);
              removeActive();
              setCurrentPoi(find);
              //console.log(selected, 'was selected');
            } else {
              // setCurrentPoi(null)
              // was deselected
            }
          }

          // clone and store the new state
          this.prevState = {
            ...newState,
            selected,
          };
        },
      });
    }
  }, [showCase, listPoi, showCase]);

  // Función auxiliar mejorada para esperar a que el espacio cargue
  const waitForSpaceToLoad = () => {
    return new Promise((resolve) => {
      // Flag para evitar resolver múltiples veces
      let hasResolved = false;

      // Contador para evitar esperar indefinidamente
      let timeoutCounter = 0;
      const MAX_TIMEOUT = 30; // 15 segundos máximo (30 * 500ms)

      // Comprobar la carga una sola vez al principio para casos donde ya está cargado
      const checkInitial = async () => {
        try {
          if (showCase && isSpaceLoad) {
            // console.log("#SM: Space already loaded, proceeding immediately");
            hasResolved = true;
            return resolve();
          }

          // Si no está cargado, comenzar el intervalo de verificación
          const intervalId = setInterval(checkIfLoaded, 500);

          // Establecer un tiempo máximo de espera
          setTimeout(() => {
            if (!hasResolved) {
              // console.warn("#SM: Space load maximum timeout reached, proceeding anyway");
              clearInterval(intervalId);
              hasResolved = true;
              resolve();
            }
          }, MAX_TIMEOUT * 500);
        } catch (error) {
          // console.error("#SM: Error in initial check:", error);
          // Iniciar verificaciones periódicas de todos modos
          const intervalId = setInterval(checkIfLoaded, 500);
        }
      };

      const checkIfLoaded = async () => {
        // Evitar resoluciones duplicadas
        if (hasResolved) return;

        // Incrementar el contador
        timeoutCounter++;

        try {
          // Si el estado isSpaceLoad ya es true, resolvemos inmediatamente
          if (isSpaceLoad) {
            // console.log("#SM: Space loaded via isSpaceLoad flag");
            hasResolved = true;
            return resolve();
          }

          // Intentar verificar el estado del SDK de Matterport
          if (showCase) {
            // Verificar si podemos acceder a los datos del modelo
            const modelData = await showCase.Model.getData();
            if (modelData && modelData.sweeps && modelData.sweeps.length > 0) {
              // console.log("#SM: Space loaded via Model Data check");
              hasResolved = true;
              return resolve();
            }

            // Verificar si la fase es PLAYING
            const appState = await showCase.App.state.get();
            if (appState.phase === showCase.App.Phase.PLAYING) {
              // console.log("#SM: Space loaded via App Phase check");
              hasResolved = true;
              return resolve();
            }

            // Verificar si podemos acceder a la cámara actual
            const camera = await showCase.Camera.getPose();
            if (camera && camera.sweep) {
              // console.log("#SM: Space loaded via Camera check");
              hasResolved = true;
              return resolve();
            }

            // Verificar si podemos acceder al sweep actual
            const currentSweep = await showCase.Sweep.current.get();
            if (currentSweep && currentSweep.sid) {
              // console.log("#SM: pace loaded via Current Sweep check");
              hasResolved = true;
              return resolve();
            }
          }
        } catch (error) {
          // Si hay errores en las comprobaciones, ignorarlos silenciosamente
          // console.log("#SM: Still checking space load state...", error.message);
        }

        // Verificar si hemos esperado demasiado tiempo
        if (timeoutCounter >= MAX_TIMEOUT) {
          // console.warn("#SM: pace load timeout reached, proceeding anyway");
          hasResolved = true;
          return resolve();
        }

        // Mostrar progreso
        // console.log(`#SM: Waiting for space to load... (${timeoutCounter}/${MAX_TIMEOUT})`);
      };

      // Iniciar el proceso de verificación
      checkInitial();
    });
  };

  // Versión mejorada de setInitialPosition
  useEffect(() => {
    // Bandera para controlar que solo intentemos posicionar una vez
    let hasTriedPositioning = false;

    const setInitialPosition = async (mpSdk) => {
      // Si ya intentamos posicionar, no hacerlo de nuevo
      if (hasTriedPositioning) return;
      hasTriedPositioning = true;

      const urlParams = new URLSearchParams(window.location.search);
      const sr = urlParams.get('sr'); // Rotación (yaw, pitch)
      const ss = urlParams.get('ss'); // Sweep Number

      // Solo proceder si tenemos los parámetros necesarios
      if (!sr || !ss) {
        // console.log("#SM: No position parameters found in URL");
        return;
      }

      const [yaw, pitch] = sr.split(',').map(Number); // Extraer yaw y pitch
      const sweepNumber = parseInt(ss, 10); // Convertir a número entero

      try {
        // console.log("#SM: Starting initial positioning sequence");

        // Esperar a que el espacio termine de cargar
        await waitForSpaceToLoad();
        // console.log('#SM: Space loaded, proceeding with positioning');

        // Verificar si aún tenemos acceso a mpSdk (podría haber cambiado durante la carga)
        if (!mpSdk) {
          console.error("SDK no longer available");
          return;
        }

        // Esperar a que el SDK esté listo
        await mpSdk.Sweep.current.waitUntil((currentSweep) => currentSweep.sid !== '');

        // Obtener los datos del modelo
        const modelData = await mpSdk.Model.getData();
        // console.log("#SM: Available sweeps:", modelData.sweeps.length);
        // console.log("#SM: Sweep Number from URL:", sweepNumber);

        // Verificar que el número de sweep sea válido
        if (sweepNumber <= 0 || sweepNumber > modelData.sweeps.length) {
          // console.error(`#SM: Invalid sweep number: ${sweepNumber}. Total sweeps: ${modelData.sweeps.length}`);
          return;
        }

        // Buscar el sweep correspondiente
        const targetSweep = modelData.sweeps[sweepNumber - 1];
        if (!targetSweep) {
          // console.error('#SM: Sweep not found:', sweepNumber);
          return;
        }

        // console.log(`#SM: Moving to sweep #${sweepNumber} (SID: ${targetSweep.sid}) with rotation: ${yaw}, ${pitch}`);

        // Mover al sweep especificado con la rotación proporcionada
        await goToSweep(targetSweep, { x: pitch, y: yaw });
        // console.log('#SM: Moved to initial position successfully');
      } catch (e) {
        // console.error('#SM: Error setting initial position:', e);
      }
    };

    // Solo ejecutar cuando showCase esté disponible y sea estable
    if (showCase && typeof showCase.App !== 'undefined') {
      // Esperar un momento para asegurar que el SDK esté estable
      setTimeout(() => {
        setInitialPosition(showCase);
      }, 1000);
    }

    // Limpieza al desmontar
    return () => {
      hasTriedPositioning = true;
    };
  }, [showCase]);

  return (
    <div
      className={classNames({
        space: true,
        "space--hide":
          !menu &&
          !(content?.text === "3D" || content?.text === "Measurements"),
      })}
    >
      <div className="space__iframe-container" ref={ref}>
        {currentPoi && (
          <ModalPoint
            hideAdd={true}
            hide={!isMainFrame}
            setPoi={setCurrentPoi}
            poi={currentPoi}
          />
        )}
        {!isOpen && (
          <div
            id="iframe-controls"
            className={classNames({
              "iframe-space__hide": isMainFrame,
              "iframe-space__show": !isMainFrame,
            })}
          >
            <MinimapSpaceBtn
              onClick={handleMain}
              className="minimap-space__btn"
              color={color}
            >
              <Replace />
            </MinimapSpaceBtn>
            <MinimapSpaceBtn
              onClick={handleOpenMinimap}
              className="minimap-space__btn"
              color={color}
            >
              <Plus style={{ transform: "rotate(45deg)" }} />
            </MinimapSpaceBtn>
          </div>
        )}
        <iframe
          onMouseEnter={() => {
            // dont have acces to trigger in css to : hover because not parent
            let getWidth = window.innerWidth;
            let getId = document.getElementById("showcase-iframe");
            if (
              getWidth > 968 &&
              getId.classList.contains("space__mini-iframe")
            ) {
              getId.classList.add("space__mini-iframe--hover");
              // let controls = document
              //   .getElementById('iframe-controls')
              //   .classList.add('iframe-space__show--hover');
            }
          }}
          onMouseLeave={(event) => {
            // dont have acces to trigger in css to : hover because not parent
            let getId = document.getElementById("showcase-iframe");
            //Check if we hover not button to control mini map
            let targetWhenLeave = event?.relatedTarget?.classList?.contains(
              "minimap-space__btn"
            )
              ? true
              : false;
            if (
              getId.classList.contains("space__mini-iframe") &&
              !targetWhenLeave
            ) {
              getId.classList.remove("space__mini-iframe--hover");
              // let controls = document
              //   .getElementById('iframe-controls')
              //   .classList.remove('iframe-space__show--hover');
            }
          }}
          style={{
            backgroundColor: "grey",
            cursor: "pointer",
          }}
          className={classNames({
            space__iframe: true,
            "space__mini-iframe": !isMainFrame,
            "space__iframe--hide": isOpen && !isMainFrame,
            space__small_height: !isOpen,
          })}
          src={`${space?.additionalposition
            ? space?.url + space?.additionalposition
            : space?.url
            }&search=0&applicationKey=${matterportSdkKey}${spaceUrlCreator()}`}
          frameBorder="0"
          allow="xr-spatial-tracking;"
          id="showcase-iframe"
        ></iframe>
        <div
          className={classNames({
            "minimap-space": isMainFrame,
            "minimap-space-full": !isMainFrame,
            "minimap-space-hide": isOpen && isMainFrame,
          })}
        >
          <div
            className={classNames({
              "minimap-space__controls": isMainFrame,
              "minimap-space__controls--hide": !isMainFrame,
              "minimap-space__controls--hide-big": isOpen && !isMainFrame,
            })}
          >
            <MinimapSpaceBtn
              onClick={handleMain}
              className="minimap-space__btn"
              color={color}
            >
              <Replace />
            </MinimapSpaceBtn>
            <MinimapSpaceBtn
              onClick={handleOpenMinimap}
              className="minimap-space__btn"
              color={color}
            >
              <Plus style={{ transform: "rotate(45deg)" }} />
            </MinimapSpaceBtn>
          </div>
          <div className="minimap-space__image-content">
            <TransformWrapper
              initialScale={1}
              minScale={0.3}
              limitToBounds={false}
              disablePadding={true}
              initialPositionX={0}
              initialPositionY={0}
              ref={zoomRef}
            >
              {({ zoomIn, zoomOut, resetTransform, centerView, ...rest }) => (
                <React.Fragment>
                  <div className="tools">
                    <MinimapSpaceBtn
                      className="minimap-space__btn minimap-space__btn--flex"
                      onClick={() => zoomIn()}
                      color={color}
                    >
                      <ZoomIn />
                    </MinimapSpaceBtn>
                    <MinimapSpaceBtn
                      className="minimap-space__btn minimap-space__btn--flex"
                      onClick={() => zoomOut()}
                      color={color}
                    >
                      <ZoomOut />
                    </MinimapSpaceBtn>
                    <MinimapSpaceBtn
                      className="minimap-space__btn minimap-space__btn--flex"
                      ref={resetZoom}
                      onClick={() => {
                        resetTransform();
                      }}
                      color={color}
                    >
                      <Reset />
                    </MinimapSpaceBtn>
                  </div>
                  <TransformComponent>
                    <img
                      src={mapImg || minimapImg?.preview}
                      alt="miniMap"
                      className="minimap-space__img"
                    />
                    {(minimapImg?.preview || mapImg) && (
                      <div
                        style={{
                          transform: `translate(${findFloor?.setting?.posWidth || 0
                            }%, ${findFloor?.setting?.posHeight || 0}%)`,
                        }}
                        className={classNames({
                          "minimap-sweeps": true,
                          "minimap-sweeps--small": isMainFrame,
                        })}
                      >
                        {floorSweeps?.map((sweep, index) => {
                          return (
                            <span
                              key={sweep.sid || index}
                              onClick={(e) => goToSweep(sweep)}
                              className={classNames({
                                "minimap-sweep": true,
                                "minimap-sweep--small": isMainFrame,
                              })}
                              style={{
                                left: `${sweep.px.right}`,
                                bottom: `${sweep.px.bottom}`,
                              }}
                            ></span>
                          );
                        })}
                        {floorPoi?.map((poi, index) => {
                          return (
                            <React.Fragment key={poi.id || index}>
                              <CustomTooltip
                                isMainFrame={isMainFrame}
                                poi={poi}
                                goToPoi={goToPoi}
                                currPoi={currentPoi}
                              />
                            </React.Fragment>
                          );
                        })}
                        {pose !== null && (
                          <Arrow
                            className={classNames("minimap-space__anchor", {
                              "minimap-space__anchor--big": !isMainFrame,
                            })}
                            style={{
                              transform: `rotate(${pose?.rotation}deg)`,
                              left: `${pose.left}`,
                              bottom: `${pose.bottom}`,
                            }}
                          />
                        )}
                      </div>
                    )}
                  </TransformComponent>
                </React.Fragment>
              )}
            </TransformWrapper>
          </div>
        </div>
        {isOpen && (
          <button
            disabled={!mapImg && !mapImg?.preview}
            onClick={handleOpenMinimap}
            className="space-show-minimap"
            data-tooltip-content={t("tooltips.showMinimap")}
          >
            <Map />
          </button>
        )}
        {isOpen && space?.userInterface?.floorsEnabled && (
          <button
            onClick={() => setFloorShow((prev) => !prev)}
            className={showMinimapClassnames}
            data-tooltip-content={t(
              floorShow ? "tooltips.hideFloor" : "tooltips.showFloor"
            )}
          >
            {showMinimapClassnames.includes("active") ? (
              <Floor fill={color} />
            ) : (
              <Floor />
            )}
          </button>
        )}
        {isSpaceLoad && floorShow && floor && floor?.length > 0 && (
          <div className="space__wrapper_floor">
            {floor
              .sort((a, b) => b.floor - a.floor)
              .map((item) => {
                return (
                  <SpaceFloor
                    key={item.id || item.floor}
                    className={classNames({
                      space_floor: true,
                      "space_floor--active": item.active,
                    })}
                    onClick={(e) => {
                      handleChangeFloor(e, item);
                    }}
                    color={color}
                  >
                    {item.floor}
                  </SpaceFloor>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Space;
